<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:31:30
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的开票</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-dateRange">
          <el-date-picker
            v-model="getListData.StartDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="开始时间"
          >
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker
            v-model="getListData.EndDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="结束时间"
          >
          </el-date-picker>
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
        <div class="right">
          <el-button @click="applyInvoicing()" class="search-btn"
            >开票</el-button
          >
        </div>
      </div>
      <ul class="my-tabs">
        <li
          class="my-tabs-item"
          :class="{ active: getListData.StatusID == item.value }"
          @click="changeTabs(item)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item.label }}
        </li>
      </ul>
      <el-table
        v-loading="isLoading"
        :data="tableData"
        class="mt20"
      >
        <el-table-column prop="InvoiceTypeTxt" label="开票类型" align="center">
        </el-table-column>
        <el-table-column
          prop="InvoiceTitle"
          label="发票抬头"
          min-width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="TaxNumber"
          label="纳税人识别号"
          min-widthwidth="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="InvoiceAmount"
          label="金额（元）"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <span class="Amount b600">{{
              scope.row.InvoiceAmount ? "¥ " + scope.row.InvoiceAmount : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="AddTime"
          label="申请时间"
          width="240"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ExpirationDateTxt"
          label="状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span class="StatusID">{{ scope.row.InvoiceStatusTxt }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { GetMyInvoiceList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "order",
  data() {
    return {
      tabs: [
        { label: "全部", value: 0 },
        { label: "待开票", value: 1 },
        { label: "已开票", value: 2 },
      ],
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        StartDate: "",
        EndDate: "",
        StatusID: 0,
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeTabs(item) {
      this.getListData.StatusID = item.value;
      this.getList();
    },
    applyInvoicing() {
      this.$router.push({
        path: "/member/applyInvoicing",
      });
    },
    hanldDetail(data) {
      this.$router.push({
        path: "/member/applyInvoicing",
        query: {
          InvoiceID: data.InvoiceID,
          type: 1,
        },
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyInvoiceList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.StatusID {
  font-size: 16px;
  color: #1d79ff;
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.my-search-box {
  position: relative;
  .right {
    position: absolute;
    right: 0;
  }
}
.el-select {
  ::v-deep .el-input__inner {
    width: 201px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
.el-date-editor {
  width: 180px;
  height: 47px;
  ::v-deep .el-input__inner {
    width: 180px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
</style>
